import React, { useCallback } from 'react';
import { Loader } from '@sunbit-dev/web-ui-lib';
import { ThemeProvider } from '@sunbit-dev/purchase-common/src/theme/ThemeProvider';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import MainContainer from './MainContainer';
import DocumentContainer from './DocumentContainer';
import { mainUrl } from '@sunbit-dev/common/helpers/url';
import UserContextProvider from '../contexts/userContext';
import LoaderContainer from './LoaderContainer';
import { GlobalStyle } from '@sunbit-dev/purchase-common/src/theme/globalStyle';
import { ApplicationSessionSetup } from '~/containers/ApplicationSessionSetup';
import { PopupProvider } from '~/components/popupProvider/PupopProvider';
import ErrorModalContainer from '~/containers/ErrorModalContainer';
import ErrorContextProvider from '../contexts/errorContext';
import { Backdrop } from '~/components/Backdrop/Backdrop';
import HealthcareModalContainer from '~/containers/HealthcareModalContainer';
import HealtcareContextProvider from '~/contexts/HealthcareContext';
import { LogsTracking } from '~/components/logsTracking/LogsTracking';
import RatesAndTermsPage from './RatesAndTermsPage';

const MainLayoutContainer = React.lazy(() => import('./MainLayoutContainer'));

const MainLayoutRoute = ({ component: Component, ...props }) => {
  const { history, location, computedMatch } = props;
  const retailerId = computedMatch?.params?.retailerId;

  // Temporary fix because of wrong link sent to retailer for SBT-35342, please consult with platform team before removal
  if (window.location.href.includes('TekmetricServiceCenter-luub')) {
    let newUrl = window.location.href.replace('TekmetricServiceCenter-luub', 'YourShopmonkeyServiceCenter-okan');
    window.history.replaceState(null, 'Sunbit - Apply online in 60 seconds', newUrl);
  }

  const renderProp = () => (
    <UserContextProvider>
      <LogsTracking />
      <MainLayoutContainer {...{ history, location, retailerId }}>
        <Component {...props} />
      </MainLayoutContainer>
    </UserContextProvider>
  );

  return <Route render={renderProp} />;
};

const App = ({ location, history }: RouteComponentProps) => {
  const redirect = useCallback(() => {
    window.location.href = mainUrl;
    return <Loader active />;
  }, []);

  return (
    <ThemeProvider>
      <GlobalStyle />
      <React.Suspense fallback={<LoaderContainer />}>
        <PopupProvider>
          <Backdrop>
            <ApplicationSessionSetup>
              <ErrorContextProvider>
                <HealtcareContextProvider>
                  <Switch>
                    <Route exact path={'/document'} component={DocumentContainer} />
                    <Route exact path={'/RatesAndTerms'} component={RatesAndTermsPage} />
                    <MainLayoutRoute exact {...{ path: '/:retailerId', component: MainContainer, history, location }} />
                    <Route render={redirect} />
                  </Switch>
                  <ErrorModalContainer {...{ history }} />
                  <HealthcareModalContainer />
                </HealtcareContextProvider>
              </ErrorContextProvider>
            </ApplicationSessionSetup>
          </Backdrop>
        </PopupProvider>
      </React.Suspense>
    </ThemeProvider>
  );
};

export default withRouter(App);
